import store from '../store';
import axios from 'axios';
import { apiStatus, HTTP_API_URL } from '../../config';
import { ERROR_HANDLER_SET, MODAL_HIDE } from './actions';
import AppError from '../../errors/apperror';
import { isNetworkStatusOffline, extractPropsforAxiosHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import Logger from '../../logger/logger';
import HttpError from '../../errors/httperror';
const log = Logger.get('apistatustester');

const ENDPOINT = apiStatus.endpoint;
const STATUS = apiStatus.status;
const protocol = location.protocol + '//';
const environmentEndpoint = HTTP_API_URL.replace(/https?:\/\/(.*?)\..*/, '$1');

const url = protocol + apiStatus.url + ENDPOINT[environmentEndpoint];

let waitingPromise, resolveWaitingPromise, nextCheck, showingError = false;

/**
 * Returns a promise for the network request and once the request returns schedules the
 * next API check
 * @returns a promise which is the api network request
 */
function isApiAvailable() {
	// in case called directly from other services, clear the next check
	clearTimeout(nextCheck);

	return new Promise((res, rej) => {
		axios.get(url).then(resolve).catch(reject);

		function resolve(response) {
			scheduleNextCheck();
			const data = response && response.data && response.data.data || {};
			switch (data.status) {
				case STATUS.ONLINE:
					hideMaintenanceMessage();
					resolveWaitingPromise && resolveWaitingPromise();
					resolveWaitingPromise = undefined;
					res(STATUS.ONLINE);
					break;

				case STATUS.MAINTENANCE:
				case STATUS.OFFLINE:
				default:
					showMaintenanceMessage(data.description);
					rej(data.status);
					break;
			}
		}

		function reject(error) {
			scheduleNextCheck();

			const httpErrorProps = extractPropsforAxiosHttpError(error);

			const nError = new AppError({
				message: 'API Status request rejected',
				errorId: ERRORS.REJECTED_API_STATUS_REQUEST,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: getVisualisersFeature(error) }
			});

			rej(nError);
		}
	});
}

function getVisualisersFeature(error) {
	return isNetworkStatusOffline(error)
		?
		'SUPPRESSED_ERROR'
		:
		'API_STATUS_TESTER';
}

function doStatusCheck() {
	isApiAvailable()
		.catch(error => {
			log.send(new AppError(
				{
					message: 'API status check failed',
					errorId: ERRORS.UNKNOWN,
					originalError: error,
					visualisers: { feature: getVisualisersFeature(error) }
				}
			));
		});
}

/**
 * Schedule the next request to test the API
 * Ensures only 1 loop of checks is running
 */
function scheduleNextCheck() {
	clearTimeout(nextCheck);
	nextCheck = setTimeout(doStatusCheck, apiStatus.timeout);
}

/**
 * waitForTheAPI
 * @returs returns a promise which resolves when the service is back online
 */
function waitForTheApi() {
	if (!resolveWaitingPromise) {
		waitingPromise = new Promise(function (resolve) {
			resolveWaitingPromise = resolve;
		});
	}

	return waitingPromise || Promise.resolve();
}

/**
 * Update application state with current error
 */
const showMaintenanceMessage = (message) => {
	store.dispatch({
		type: ERROR_HANDLER_SET,
		error: {
			errorMessage: message,
			errorId: ERRORS.WAITING_FOR_API
		}
	});
	showingError = true;
};

/**
 * Clear the application state of the current error
 */
const hideMaintenanceMessage = () => {
	showingError && store.dispatch({
		type: MODAL_HIDE
	});
	showingError = false;
};

// delay to allow for all animation and z-index construction in event of error on load
setTimeout(doStatusCheck, 2000);

export default {
	waitForTheApi: waitForTheApi,
	isApiAvailable : isApiAvailable,
	_spec: {
		showMaintenanceMessage: showMaintenanceMessage,
		hideMaintenanceMessage: hideMaintenanceMessage,
		scheduleNextCheck: scheduleNextCheck
	}
};


// WEBPACK FOOTER //
// ./src/redux/modules/apistatustester.js